import CircularProgress from "@mui/material/CircularProgress";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useEffect, useState } from "react";
import styles from "./transactionblock.module.css";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { updateOrderPayment } from "../../apis/payment";
import { formatPrice } from "../../utils/product";
export default function TransactionBlock() {
  const { t } = useTranslation();
  // const [orderDetail, setOrderDetail] = useState({
  //   orderAmount: "429.000",
  //   orderInfo: "thanh toan hoa don bhive",
  //   ipAddress: "192.168.1.1",
  //   billingAddress: "123 duong 3/2",
  //   bankCode: "NCB",
  //   bankTransaction: "GDT202109231",
  //   payDate: "2021-09-23 11:00:00",
  //   transactionStatus: "PENDING",
  // });
  const location = useLocation();
  const navigate = useNavigate();
  const [cookie, setCookie] = useCookies(["access_token"]);

  const params = new URLSearchParams(location.search);

  const [paymentStatus, setPaymentStatus] = useState({
    amount: "",
    bankCode: "",
    bankTranNo: "",
    cardType: "",
    orderInfo: "",
    payDate: "",
    responseCode: "",
    tmnCode: "",
    transactionNo: "",
    transactionStatus: "",
    bhiveTransactionNo: "",
    secureHash: "",
  });
  useEffect(() => {
    console.log(params.get("vnp_Amount")); //required
    console.log(params.get("vnp_BankCode")); //required
    console.log(params.get("vnp_BankTranNo")); //optional
    console.log(params.get("vnp_CardType")); //optional
    console.log(params.get("vnp_OrderInfo")); //required
    console.log(params.get("vnp_PayDate")); //optional
    console.log(params.get("vnp_ResponseCode")); //required
    console.log(params.get("vnp_TmnCode")); //required
    console.log(params.get("vnp_TransactionNo")); //required
    console.log(params.get("vnp_TransactionStatus")); //required
    console.log(params.get("vnp_TxnRef")); //required
    console.log(params.get("vnp_SecureHash")); //required
    if (
      !params.get("vnp_Amount") ||
      !params.get("vnp_TmnCode") ||
      !params.get("vnp_BankCode") ||
      !params.get("vnp_OrderInfo") ||
      !params.get("vnp_TransactionNo") ||
      !params.get("vnp_ResponseCode") ||
      !params.get("vnp_TransactionStatus") ||
      !params.get("vnp_TxnRef") ||
      !params.get("vnp_SecureHash")
    ) {
      navigate("/cart");
    } else {
      updateOrderPayment(location.search, cookie["access_token"]);
      setPaymentStatus({
        amount: params.get("vnp_Amount"),
        bankCode: params.get("vnp_BankCode"),
        bankTranNo: params.get("vnp_BankTranNo"),
        cardType: params.get("vnp_CardType"),
        orderInfo: params.get("vnp_OrderInfo"),
        payDate: params.get("vnp_PayDate"),
        responseCode: params.get("vnp_ResponseCode"),
        tmnCode: params.get("vnp_TmnCode"),
        transactionNo: params.get("vnp_TransactionNo"),
        transactionStatus: params.get("vnp_TransactionStatus"),
        bhiveTransactionNo: params.get("vnp_TxnRef"),
        secureHash: params.get("vnp_SecureHash"),
      });
    }
  }, []);

  function formatDate(dateString) {
    const year = parseInt(dateString.substring(0, 4));
    const month = parseInt(dateString.substring(4, 6)) - 1; // JavaScript months are 0-11
    const day = parseInt(dateString.substring(6, 8));
    const hour = parseInt(dateString.substring(8, 10));
    const minute = parseInt(dateString.substring(10, 12));
    const second = parseInt(dateString.substring(12, 14));
    const date = new Date(year, month, day, hour, minute, second);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
  }
  const renderDetail = (label, value) => {
    if (value === "" || value === undefined) {
      return null;
    }
    return (
      <div className={styles.transactionDetail}>
        <span className={styles.dataType}>{label}:</span>
        <span className={styles.data}>{value}</span>
      </div>
    );
  };
  const [status, setStatus] = useState("");
  const [statusIcon, setStatusIcon] = useState(
    <CircularProgress
      size={100}
      sx={{ color: "#E7851A", marginTop: "120px", marginBottom: "70px" }}
    />
  );
  const [colorStatus, setColorStatus] = useState("#E7851A");
  useEffect(() => {
    if (status === "SUCCESS") {
      setStatusIcon(
        <CheckCircleOutlineIcon
          sx={{
            fontSize: 150,
            color: "#4CAF50",
            marginTop: "120px",
            marginBottom: "70px",
          }}
        />
      );
      setColorStatus("#4CAF50");
    } else if (status === "REJECT") {
      setStatusIcon(
        <HighlightOffIcon
          sx={{
            fontSize: 150,
            color: "red",
            marginTop: "120px",
            marginBottom: "70px",
          }}
        />
      );
      setColorStatus("red");
    } else {
      setStatusIcon(
        <CircularProgress
          size={100}
          sx={{ color: "#E7851A", marginTop: "120px", marginBottom: "70px" }}
        />
      );
      setColorStatus("#E7851A");
    }
  }, [status]);
  useEffect(() => {
    switch (paymentStatus.transactionStatus) {
      case "00":
        setStatus("SUCCESS");
        break;
      case "01" || "05" || "06":
        setStatus("PENDING");
        break;
      case "02" || "04" || "07" || "09":
        setStatus("REJECT");
        break;
      default:
        setStatus("PENDING");
        break;
    }
  }, [paymentStatus.transactionStatus]);

  return (
    <div className={styles.transactionPendingBlock}>
      <div className={styles.header}>
        {statusIcon}
        <h2 style={{ color: `${colorStatus}` }}>{status}</h2>
      </div>
      <div className={styles.body}>
        {renderDetail(
          t("order_amount"),
          `${formatPrice(paymentStatus.amount)}`
        )}
        {renderDetail(t("order_info"), paymentStatus.orderInfo)}
        {renderDetail(t("card_type"), paymentStatus.cardType)}
        {renderDetail(t("bank_code"), paymentStatus.bankCode)}
        {renderDetail(t("bank_transaction"), paymentStatus.bankTranNo)}
        {renderDetail(t("pay_date"), formatDate(paymentStatus.payDate))}
        {renderDetail(t("respond_code"), paymentStatus.responseCode)}
        {renderDetail(t("tmn_code"), paymentStatus.tmnCode)}
        {renderDetail(t("transaction_no"), paymentStatus.transactionNo)}
        {renderDetail(
          t("bhive_transaction_no"),
          paymentStatus.bhiveTransactionNo
        )}
        {renderDetail(t("transaction_status"), paymentStatus.transactionStatus)}
      </div>
    </div>
  );
}
